const ASANA_AUTH_REQUIRED_TEXT = '*Asana authentication required  ';

export {
  ASANA_AUTH_REQUIRED_TEXT,
}